export default function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}


//////////////////
// WEBPACK FOOTER
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/node_modules/swiper/esm/components/core/classes/removeClasses.js
// module id = 97
// module chunks = 0